var _g, _path, _path2, _path3, _defs;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgWhatsappIcon(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 39,
    height: 40,
    viewBox: "0 0 39 40",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter0_f_557_906)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M13.9651 28.0548L14.3396 28.2766C15.9126 29.2101 17.7162 29.704 19.5554 29.7048H19.5593C25.2075 29.7048 29.8043 25.1091 29.8066 19.4605C29.8076 16.7232 28.7427 14.1492 26.808 12.2129C25.859 11.258 24.7301 10.5008 23.4866 9.98515C22.243 9.46948 20.9095 9.20559 19.5633 9.20876C13.9107 9.20876 9.31375 13.804 9.31173 19.4523C9.30895 21.381 9.85208 23.2711 10.8783 24.9041L11.1222 25.2915L10.0867 29.0716L13.9651 28.0548ZM7.12646 32L8.87572 25.6133C7.79691 23.7442 7.22935 21.6238 7.23002 19.4514C7.23287 12.6555 12.7633 7.12671 19.5594 7.12671C22.8574 7.12838 25.9529 8.4118 28.2809 10.7415C30.6089 13.0712 31.8898 16.1679 31.8887 19.4613C31.8857 26.2567 26.3544 31.7865 19.5593 31.7865H19.5539C17.4906 31.7857 15.4632 31.2681 13.6623 30.2861L7.12646 32Z",
    fill: "#B3B3B3"
  }))), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M7 31.8733L8.74926 25.4866C7.66859 23.613 7.10095 21.4876 7.10356 19.3247C7.10641 12.5288 12.6369 7 19.433 7C22.7309 7.00168 25.8264 8.28509 28.1544 10.6148C30.4825 12.9445 31.7634 16.0412 31.7622 19.3346C31.7592 26.13 26.2279 31.6598 19.4328 31.6598H19.4274C17.3642 31.659 15.3367 31.1414 13.5359 30.1594L7 31.8733Z",
    fill: "white"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M19.4366 9.08206C13.784 9.08206 9.18708 13.6773 9.18507 19.3256C9.18229 21.2543 9.72542 23.1444 10.7517 24.7774L10.9955 25.165L9.96008 28.945L13.8386 27.9281L14.2132 28.1499C15.7861 29.0835 17.5897 29.5771 19.4289 29.5781H19.4328C25.081 29.5781 29.6779 24.9824 29.6801 19.3338C29.6844 17.9875 29.4216 16.6537 28.9068 15.4096C28.3921 14.1656 27.6357 13.036 26.6815 12.0862C25.7325 11.1313 24.6036 10.3741 23.36 9.85842C22.1164 9.34275 20.7829 9.07887 19.4366 9.08206Z",
    fill: "url(#paint0_linear_557_906)"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M16.3514 14.1722C16.1205 13.6592 15.8776 13.6488 15.6582 13.64L15.0677 13.6328C14.8623 13.6328 14.5285 13.7098 14.2463 14.0182C13.9641 14.3265 13.168 15.0717 13.168 16.5873C13.168 18.103 14.2719 19.5675 14.4257 19.7733C14.5796 19.9791 16.5569 23.1886 19.6883 24.4234C22.2904 25.4496 22.82 25.2455 23.385 25.1942C23.95 25.1429 25.2076 24.449 25.4642 23.7296C25.7207 23.0103 25.7209 22.3939 25.644 22.2651C25.5671 22.1362 25.3616 22.0596 25.0533 21.9055C24.745 21.7513 23.2307 21.0061 22.9483 20.9032C22.666 20.8004 22.4607 20.7492 22.2551 21.0576C22.0495 21.3659 21.4598 22.0595 21.28 22.2651C21.1002 22.4707 20.9207 22.4965 20.6124 22.3425C20.3041 22.1885 19.3121 21.8631 18.1351 20.8136C17.2193 19.997 16.6011 18.9886 16.4212 18.6804C16.2412 18.3723 16.4021 18.2054 16.5566 18.0519C16.6948 17.9138 16.8645 17.6921 17.0189 17.5123C17.1732 17.3325 17.224 17.204 17.3265 16.9987C17.4291 16.7934 17.378 16.6131 17.3009 16.4591C17.2238 16.3051 16.6253 14.7816 16.3514 14.1723",
    fill: "white"
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("filter", {
    id: "filter0_f_557_906",
    x: 0.064465,
    y: 0.0647092,
    width: 38.8862,
    height: 38.9973,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "BackgroundImageFix",
    result: "shape"
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 3.531,
    result: "effect1_foregroundBlur_557_906"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_557_906",
    x1: 19.224,
    y1: 10.312,
    x2: 19.3279,
    y2: 27.8272,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#57D163"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#23B33A"
  })))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgWhatsappIcon);
export default __webpack_public_path__ + "static/media/whatsapp_icon.d9b25368247140079929176df139745a.svg";
export { ForwardRef as ReactComponent };